module.exports = __webpack_public_path__ + "img/Bosowa Multifinance.fa1441e1.png";